import React, {useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import  Divider  from '@mui/material/Divider';
import  Chip  from '@mui/material/Chip';
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import {Footer} from './Footer';
import {Header} from './Header';
import ErrorIcon from '@mui/icons-material/Error';
import { credientials } from '../credientials';
import { Message } from './Message';
import { CheckInvoice } from './CheckInvoice';
import { Loader } from './Loader';
import { DuplicateMessage } from './DuplicateMessage';

  export const Paymybill =() =>{


    let params = new URLSearchParams(window.location.search);
    let invoice = params.get("INV");
    let amount = params.get("AMT");
    let client = params.get("CRF");
    
    let dollars = "$" + (amount / 100).toFixed(2);

    //handle modal open close on submit
    const [urlCheck, setUrlCheck] = useState(true);

    useEffect(() => {
        if(invoice && amount && client){
          setUrlCheck(false);
        }else{
          setUrlCheck(true);
        }
    }, [invoice, amount, client]);

    console.log(urlCheck);

    
    
    const {
        wrapperProps,
        getCardImageProps,
        getCardNumberProps,
        getExpiryDateProps,
        getCVCProps
      } = usePaymentInputs();

    const [disable, setDisable] = useState();
    const [invoiceAdd, setInvoiceAdd] = useState(false);
    
    const [email, setEmail] = useState();
    const [submitText, setSubmitText] = useState();
    const [loading, setLoading] = useState(false);
    const [duplicate, setDuplicate] = useState(false);
    const [datePaid, setDatePaid] = useState('');

    //handle modal open close on submit
    const [open, setOpen] = useState(false);

    
    const [success, setSuccess] = useState(false);
    const [icon, setIcon] = useState();

    const [color, setColor] = useState();

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 3,
      width: '400px',
      //minHeight: '400px',
      alignItems: 'center',
      justifyContent:'center',
    };

    const addInvoice = (invoice, client, amount) =>{
      const invoiceOptions = {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "Amount": amount,
          "Invoice": invoice,
          "Client": client,
          "Action": "Add"
          
        }),
      };

      fetch(credientials.CheckInvoiceUrl, invoiceOptions)
        .then(response => {
            return response.json().then(data =>{
                console.log("Invoice added");
                if(data.error){
                    setInvoiceAdd(true);
                }else{
                    setInvoiceAdd(false);
                }
            });
        });
    }

    const handleConfirmationEmail = ( requestOptions) =>{

       

        fetch(credientials.logicApp, requestOptions)
          .then(response => {
            console.log("email sent");
          });
    }

    const handleSubmit = (event) => {
      setOpen(true);
      setSuccess(null);
      setColor(null);
      setLoading(true);
      let cc = event.target.form.cardNumber.value;
      let cvc = event.target.form.cvc.value;
      let ed = event.target.form.expiryDate.value;
      let email = event.target.form.email.value;
      let firstName = event.target.form.firstName.value;
      let lastName = event.target.form.lastName.value;

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: firstName,
          lastName: lastName,
          email: email,
          amountPayable: dollars,
          invoiceNo: invoice,
          clientNo: client
         })
        }
      //payment json.
        const paymentOptions = {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "Amount": amount,
            "CardNumber": cc, 
            "Client": client,
            "Invoice": invoice,
            "CRN3": "",
            "CVC": cvc,
            "ExpiryDate": ed,
            "Action": "Payment"
          }),
        };

        //fetch 
        fetch(credientials.PayMyBillUrl, paymentOptions)
          .then(response => {
            return response.json().then(data =>{
              console.log(data);
                if(data.error){
                  if(data.duplicate){
                    setDuplicate(true);
                    setDatePaid(data.date);
                  }else{
                    // if payment fails - execute
                    setColor('error');
                    setSubmitText(data.message);
                    setIcon(false);
                    setSuccess(false);
                    setLoading(false);
                  }
                  console.log(data.date);
                  
                }else{
                  //successful payment
                  setEmail(email);
                  setIcon(true);
                  setSuccess(true);
                  setDisable(true);
                  setColor('success');
                  setLoading(false);
                  setSubmitText("Thank you for your payment. A confirmation email has been sent to "+email);
                  //adds the invoice to the DB
                  addInvoice(invoice, client, amount);
                  
                  //handles the confirmatione email.
                  handleConfirmationEmail( requestOptions);
                }
            });
            
          });
  
    }
      
    return (
      <>
      <CheckInvoice invoice={invoice} amount={amount} client={client} style={style}></CheckInvoice>
      <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          //width: 600,
          p:3,
        },
      }}
    >
      <Paper elevation={3}>
        <Header></Header>
        <Typography variant="h4" sx={{mb:4}} gutterBottom>
            Pay My Bill
        </Typography>
        <Divider sx={{mb:2}}>
            <Chip label="Invoice Details" />
        </Divider>
      <Grid
        container
        spacing={2}
        sx={{mb:3}}
      >
            <Grid item xs={4} md={4}>
                <Typography variant="body1" gutterBottom>
                    Invoive:
                </Typography>
                <Typography variant="h6" sx={{fontWeight:600}} gutterBottom>
                    {invoice}
                </Typography>
            </Grid>
            <Grid item xs={4} md={4}>
                <Typography variant="body1" gutterBottom>
                    Amount:
                </Typography>
                <Typography variant="h6" sx={{fontWeight:600}} gutterBottom>
                    {dollars}
                </Typography>
            </Grid>
            <Grid item xs={4} md={4}>
                <Typography variant="body1" gutterBottom>
                    Client:
                </Typography>
                <Typography variant="h6" sx={{fontWeight:600}} gutterBottom>
                    {client}
                </Typography>
            </Grid>
        </Grid>
<form>
    
        <Divider sx={{mb:3}}>
            <Chip label="Your Details" />
        </Divider>
            <Grid
                container
                spacing={2}
                sx={{mb:3}}
            >
                <Grid item xs={12} md={6}>
                <TextField
                    required
                    id="first-name"
                    label="First Name"
                    name="firstName"
                    fullWidth
                    disabled={disable}
                />
                </Grid>
                <Grid item xs={12} md={6}>
                <TextField
                    required
                    id="last-name"
                    label="Last Name"
                    name="lastName"
                    fullWidth
                    disabled={disable}
                />
                </Grid>
                <Grid item xs={12} md={12}>
                <TextField
                    required
                    id="email"
                    label="Email"
                    name="email"
                    margin="normal"
                    fullWidth
                    disabled={disable}
                />
                </Grid>
                
            
        </Grid>

        <Divider sx={{mb:5}}>
            <Chip label="Card Details" />
        </Divider>
            <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                sx={{mb:5}}
                
            >
                <PaymentInputsWrapper {...wrapperProps}>
                    <svg {...getCardImageProps({ images })} />
                    <input {...getCardNumberProps()} disabled={disable}/>
                    <input {...getExpiryDateProps()} disabled={disable}/>
                    <input {...getCVCProps()} disabled={disable}/>
                </PaymentInputsWrapper>
                
            
        </Grid>
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            
        >
            <Button variant="contained" color="success" fullWidth onClick={handleSubmit} disabled={disable}>
                Pay
            </Button>
        </Grid>
        </form>
        <Footer></Footer>
          </Paper>
        </Box>


        <Modal
            open={urlCheck}
            //onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
          <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }} textAlign="center">
            <ErrorIcon sx={{ fontSize: 40 }} color="error" />
            </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" alignItems="center" textAlign="center">
              URL is not valid. Please use the invoice reference and full amount.
            </Typography>
            <Box textAlign="center" alignItems="center" justifyContent="center" sx={{mt:2}}>
            </Box>
          </Box>
        </Modal>
          {duplicate ? <DuplicateMessage datePaid={datePaid}
              client={client}
              invoice={invoice}
              dollars={dollars}
              message={submitText}
              open={open}
              style={style}
              >
              </DuplicateMessage> : ''}
          {loading ? <Loader loading={loading} style={style}></Loader>  :
            <Message 
              success={success} 
              icon={icon} 
              message={submitText} 
              email={email} 
              style={style} 
              open={open} 
              color={color}
              datePaid={datePaid}
              client={client}
              invoice={invoice}
              dollars={dollars}
            >
            </Message> }
            
          
      </>
    );
  }